export default {"src":"/_next/static/media/hamburger.d10341a2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};